module.exports = __webpack_public_path__ + "img/sd.b6f892cb.svg";